import { render, staticRenderFns } from "./approve_view.vue?vue&type=template&id=17f06e3c&scoped=true"
import script from "./approve_view.vue?vue&type=script&lang=js"
export * from "./approve_view.vue?vue&type=script&lang=js"
import style1 from "./approve_view.vue?vue&type=style&index=1&id=17f06e3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f06e3c",
  null
  
)

export default component.exports